import Dashboard from "..";

/** Dashboard → Performance sub-page: tool executions, security, feedback, session quality, customer health. */
const DashboardPerformance = () => <Dashboard section="performance" />;

export default DashboardPerformance;
